/* eslint-disable eslint-comments/no-restricted-disable */
/* eslint-disable @atlassian/react-entrypoint/entrypoint-root-module-path */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { ObjectListFlyoutEntryPointRuntimeProps } from '@atlassian/navigation-common/types';
import parameters, {
	type JiraFavouriteFilter,
} from './__generated__/useStarredItemsQuery.graphql.ts';

type EntryPointParams = {
	cloudId: string;
	filter: JiraFavouriteFilter;
	count: number;
};

type StarredFlyoutEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	Record<string, never>,
	// Disabled because the entrypoint component imported from platform
	// eslint-disable-next-line @atlassian/react-entrypoint/entrypoint-component-props-from-entrypoint-types
	ObjectListFlyoutEntryPointRuntimeProps,
	Record<string, never>
>;

export const starredFlyoutEntrypoint: EntryPoint<
	StarredFlyoutEntryPointComponent,
	EntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction<StarredFlyoutEntryPointComponent>(
		/* webpackChunkName: "async-object-list-flyout-entrypoint" */ '@atlassian/global-side-navigation/flyout-menu-item-content',
		{ moduleId: 'objectListFlyoutEntrypoint' },
	),
	getPreloadProps: ({ cloudId, filter, count }: EntryPointParams) => ({
		queries: {
			starredMenuData: {
				parameters,
				options: { fetchPolicy: 'store-and-network' as const },
				variables: { cloudId, count, filter },
			},
		},
	}),
});
